import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import Feng from "@/api/Feng";
import { Toast } from "vant";
import "amfe-flexible/index.js";

Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
Vue.prototype.$feng = Feng;
Vue.prototype.$toast = Toast;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
